module.exports = __webpack_public_path__ + "img/user.9e98fe79.svg";